import type { FaireProductEntity } from "../../entity_types/product";

export const p_kegk8gj54h: FaireProductEntity = {
  token: "p_kegk8gj54h",
  type: "product",
  name: "Peacock Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d4ad21d2a4bb599e68c9d2d71e3d77f04bc0b2b83143c196d96c831d8f020c9c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8cec7585c05ec096a90b5a518439300fd7c359e4ebb2901a9cb4dcd83b8ee3e0.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:12.635Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
